<template>
	<li
		class="menu_item__parent"
		@mouseover="show = true"
		@mouseleave="show = false"
		:class="{
      last: menuNumber === menuLength - 1,
      'has-children': this.$attrs['has-children'],
      selected: this.$attrs['selected'],
    }"
		:style="{'--nav-height': this.$store.state.alert_bar_closed ? (navHeight ? navHeight : 0) + 'px' : (navHeight ? navHeight : 0) + 'px'}"
	>
		<div
			class="parent_container"
			ref="parentElement"
		>
			<a
				class="menu_item__parent__primary_link"
				:href="localUrlSwap(menu_item['url'])"
				:target="menu_item['target']"
				v-html="menu_item['title']"
			></a>

			<svg
				v-if="menu_item['target'] === '_blank'"
				class="external_link"
				width="23"
				height="23"
				viewBox="0 0 23 23"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M19.3174 2.90485H15.0645V0.904846H22.7315V8.57185H20.7315V4.31918L10.2166 14.8349L8.80237 13.4208L19.3174 2.90485ZM0.731506 4.23987H10.6205V6.23987H2.73151V20.9029H17.3985V13.0139H19.3985V22.9029H0.731506V4.23987Z"
					fill="black"
				/>
			</svg>

			<div
				class="has-children-indicator"
				v-if="this.$attrs['has-children']"
				:class="{ hovered: this.show }"
			>
				<svg
					width="14"
					height="9"
					viewBox="0 0 14 9"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M6.80688 5.58548L12.0996 0.292786L13.5138 1.707L6.80688 8.41391L0.0999756 1.707L1.51419 0.292786L6.80688 5.58548Z"
						fill="#00AEEF"
					/>
				</svg>

			</div>
		</div>

		<transition name="slide-fade">
			<div
				class="inner_menu_child"
				v-if="show && menu_item['children']"
			>
				<div class="color-wrapper">
					<div class="menu__child">
						<div
							class="menu__arrow"
							ref="greenArrow"
						></div>
						<div
							class="menu_item__child"
							:class="{ last: the_index != 0 }"
						>
							<div class="sub_sub_container container">
								<div class="parent_menu_wrapper">
									<h2 v-html="menu_item['title']"></h2>
									<p
										v-if="menu_item['description']"
										v-html="menu_item['description']"
									></p>
								</div>

								<div
									class="sub_menus"
									:class="{'no-desc': !menu_item['call_to_action_link']}"
								>
									<div
										class="sub_menus_inner"
										v-for="(sub_menu_item, index) in menu_item['children']"
										:key="index"
									>
										<ul class="sub_sub">
											<h5
												v-if="sub_menu_item && !sub_menu_item.classes.includes('hidden-title')"
												v-html="sub_menu_item['title']"
												class="sub_menu_item"
												:class="sub_menu_item['classes'].join(', ')"
											></h5>

											<li
												v-for="(sub_sub_menu_item, index) in sub_menu_item[
                          'children'
                        ]"
												:key="index"
												:class="[sub_sub_menu_item['classes'].join(', '), {'has-icon': sub_sub_menu_item['menu_icon']}]"
											>
												<div
													class='icon-wrapper'
													v-if="sub_sub_menu_item['menu_icon']"
												>
													<img
														:src="sub_sub_menu_item['menu_icon']"
														:alt="sub_sub_menu_item['title']"
													/>
												</div>
												<a
													class="body"
													:class="sub_sub_menu_item['classes'].join(', ')"
													:href="localUrlSwap(sub_sub_menu_item['url'])"
													:target="sub_sub_menu_item['target']"
													v-html="sub_sub_menu_item['title']"
												>
												</a>

												<svg
													v-if="sub_sub_menu_item['classes'].includes('sub-cta')"
													width="7"
													height="11"
													viewBox="0 0 7 11"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														fill-rule="evenodd"
														clip-rule="evenodd"
														d="M4.09024 5.14457L0.555176 1.60893L1.96951 0.194832L6.91845 5.14459L1.9695 10.0942L0.555184 8.68012L4.09024 5.14457Z"
														fill="#4F58F5"
													/>
												</svg>

											</li>
										</ul>
									</div>
								</div>

								<div
									class='sub_menu_cta'
									v-if="menu_item['call_to_action_link']"
									:class="{'has-cta': menu_item['call_to_action_link'] != null}"
								>
									<h3 v-html="menu_item['call_to_action_description']"></h3>

									<div
										class='sub_menu_cta__wrapper'
										v-if="menu_item['call_to_action_link']"
									>
										<secondary-button
											:link="menu_item['call_to_action_link']"
											:label="menu_item['call_to_action_link'].title"
											:target="menu_item['call_to_action_link'].target"
										></secondary-button>
									</div>
								</div>
							</div>

							<!-- <div
								class="overlay"
								v-if="menu_item['children'].length"
							></div> -->
						</div>
					</div>
				</div>
			</div>
		</transition>
	</li>
</template>

<script>
import SecondaryButton from './SecondaryButton.vue';

export default {
	data() {
		return {
			param: undefined,
			selected: {},
			removed: {},
			sidePanelVisible: false,
			show: false,
			selectedMenuImage: false,
			topScrollThreshold: 100,
			windowInnerWidth: 0,
			isScrolled: false,
			isOffscreen: false,
			window: {
				width: 0,
				height: 0,
			},
		};
	},
	props: {
		menu_item: {},
		currentMenuItem: {
			type: Boolean,
			default: false,
		},
		imagePath: {},
		menuLength: {
			default: 0,
		},
		menuNumber: {
			default: 0,
		},
		the_index: {},
		locale: {},
		navHeight: {},
	},
	computed: {},
	watch: {
		show() {
			this.isScrolled = true;
			this.$emit('menuShow', this.show);
		},
	},

	methods: {
		getAndLogHorizontalPosition() {
			const parentElement = this.$refs.parentElement;
			const greenArrow = this.$refs.greenArrow;
			const horizontalPosition = this.getHorizontalPosition(parentElement);
			greenArrow
				? (greenArrow.style.left =
						horizontalPosition - 15 / 2 + parentElement.clientWidth / 2 + 'px')
				: null;
		},
		getHorizontalPosition(element) {
			let position = 0;

			while (element) {
				position += element.offsetLeft;
				element = element.offsetParent;
			}

			return position;
		},

		localeParse(url) {
			if (this.locale != 'en_au') {
				const localeUpdate = new URL(url);
				return '/' + this.locale + localeUpdate.pathname;
			} else {
				return url;
			}
		},

		didScroll() {
			this.isScrolled = window.scrollY > this.topScrollThreshold;
		},

		localUrlSwap(value) {
			if (window.location.host === 'localhost:3000') {
				return value.replace('live-in-sa.test', 'localhost:3000');
			} else {
				return value;
			}
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	name: 'MenuItem',
	components: {
		SecondaryButton,
	},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('scroll', this.didScroll);
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('scroll', this.didScroll);
	},

	mounted() {
		this.handleResize();
	},

	updated() {
		this.handleResize();
		this.getAndLogHorizontalPosition();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

/* .overlay {
	position: absolute;
	z-index: 0;
	// top: 0;
	// right: 0;
	// bottom: 100%;
	// left: 0;
	width: 100%;
	height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	pointer-events: none;
} */

.parent_container {
	position: relative;
	z-index: 200;
	display: flex;
	align-items: center;
	column-gap: 10px;
	padding: 18px 20px;
	z-index: 10;

	svg {
		&.external_link {
			height: 16px;
			width: auto;

			path {
				fill: var(--cobalt);
			}
		}
	}

	&:hover {
		/* cursor: pointer; */

		// > a {
		//   color: var(--live-blue);
		//   transition: color 0.2s ease;
		//   cursor: pointer;
		// }

		.has-children-indicator {
			svg {
				transition: 0.2s ease all;
				transform: rotate(180deg);

				path {
					fill: var(--cobalt);
				}
			}
		}
	}
}

li {
	display: flex;

	&:hover {
		color: var(--cobalt);
	}

	a {
		color: var(--midnight);
		font: normal normal normal 16px/24px var(--primary-font-family);
		display: flex;
		align-items: center;
		transition: color 0.2s ease;
		align-items: flex-start;
		text-decoration: none;

		&:hover {
			color: var(--cobalt);
			transition: color 0.2s ease;
			cursor: pointer;
		}
	}

	.has-children-indicator {
		width: 10px;
		height: 10px;
		display: flex;
		justify-content: center;
		align-items: center;

		// &:hover {
		// 	svg {
		// 		path {
		// 			fill: red;
		// 		}
		// 	}
		// }

		svg {
			width: 100%;
			transition: 0.2s ease all;
			transform: rotate(0deg);

			path {
				fill: var(--cobalt);
				transition: color 0.2s ease;
			}
		}
	}

	&.menu_item__parent {
		color: var(--white);
		display: flex;
		height: 100%;
		align-items: center;

		a.menu_item__parent__primary_link {
			position: relative;
			transition: color 0.2s ease;

			&:hover {
				color: var(--cobalt);
				transition: color 0.2s ease;
				text-decoration: underline;

				.has-children-indicator {
					svg {
						path {
							fill: var(--cobalt);
							transition: color 0.2s ease;
						}
					}
				}
			}
		}

		&.last {
			div.inner_menu_child {
				ul.menu__child {
					display: flex;
					flex-direction: column;
					grid-column: 2 / span 1;
					left: unset;

					li {
						justify-content: flex-end;
					}
				}
			}
		}
	}

	div.menu_item__child {
		&.last {
			.sub_sub_container {
				/* border-top: 1px solid var(--white);
				border-bottom: 1px solid var(--white); */
			}
		}
	}

	div.inner_menu_child {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		z-index: -10;

		.color-wrapper {
			display: flex;
			width: 100%;
			height: auto;
			padding: var(--nav-height) 0 60px;
		}

		div.menu__child {
			list-style: none;
			padding: 0;
			grid-column: 2 / span 1;
			background: var(--white);
			min-height: auto;
			display: flex;
			flex-direction: column;
			grid-column: initial;
			position: absolute;
			left: 0;
			width: 100%;
			height: auto;
			top: var(--nav-height);

			/* border-bottom: 1px solid var(--medium-grey); */

			box-shadow: -1px -1px 0px 0px var(--medium-grey) inset;
			-webkit-box-shadow: -1px -1px 0px 0px var(--medium-grey) inset;
			-moz-box-shadow: -1px -1px 0px 0px var(--medium-grey) inset;

			.scrolled & {
				top: 60px;
				border-top: 1px solid var(--medium-grey);
			}

			.menu__arrow {
				position: absolute;
				top: -8px;
				width: 15px;
				height: 15px;
				border-top: 1px solid var(--white);
				border-left: 1px solid var(--white);
				background: var(--white);
				transform: rotate(45deg);
				display: none;
			}

			&.has_overflow {
				li {
					justify-content: flex-end;
				}
			}

			/* li,
			h2,
			div {
				a {
					color: var(--midnight);

					&:hover {
						color: var(--cobalt);
					}
				}
				&:hover {
					a {
						color: var(--cobalt);
					}
				}
			} */

			.sub_sub_container {
				display: grid;
				grid-template-columns: auto 1fr 1fr 300px;
				gap: 20px;

				/* padding-top: 30px;
				padding-bottom: 30px; */

				/* .scrolled & {
					padding-top: 30px;
				} */

				.parent_menu_wrapper {
					grid-column: span 1;
					padding-top: 30px;
					padding-bottom: 30px;
					padding-right: 100px;
					max-width: 200px;

					h2 {
						margin: 0;
						/* font: normal normal normal 28px/32px var(--primary-font-family); */
						color: var(--cobalt);
					}

					p {
						color: var(--cobalt);
					}
				}

				.sub_menus {
					grid-column: span 2;
					display: grid;
					grid-template-columns: 280px 1fr;
					column-gap: 24px;
					row-gap: 24px;
					padding-top: 30px;
					padding-bottom: 30px;

					&.no-desc {
						grid-column: span 3;
						grid-template-columns: 280px 1fr 1fr;
					}

					ul {
						display: flex;
						flex-direction: column;
					}
				}

				.sub_menu_cta {
					grid-column: span 1;
					background: var(--emerald);
					/* margin-top: -30px;
					margin-bottom: -30px;
					margin-right: -24px; */
					padding: 24px;
					display: flex;
					flex-wrap: wrap;
					flex-direction: column;
					justify-content: flex-start;
					position: relative;

					&.has-cta {
						justify-content: space-between;
					}

					&::after {
						content: '';
						position: absolute;
						top: 0;
						bottom: 0;
						right: -100vw;
						height: 100%;
						width: 100vw;
						background: var(--emerald);
					}

					h3 {
						margin-top: 0;
						color: var(--midnight);
					}
				}

				a:not(.site_button_secondary) {
					&:hover {
						text-decoration: underline;
					}
				}
			}

			.sub_sub {
				grid-column: 2 / span 3;
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				row-gap: 24px;
				column-gap: 24px;
				padding-left: 0;

				h5 {
					color: var(--cobalt);
					text-transform: uppercase;
					margin: 0;

					&.hidden-title {
						display: none;
					}

					&.sub-cta {
						font-weight: 600;
						font-size: 15px;
						line-height: 18px;
					}
				}

				li {
					display: flex;
					flex-wrap: wrap;
					align-items: center;

					&.has-icon {
						display: grid;
						grid-template-columns: 32px 1fr;
						gap: 16px;
					}

					&.sub-cta {
						margin-top: 8px;
					}

					.icon-wrapper {
						margin-right: 16px;
						width: 32px;
						display: flex;
					}

					svg {
						margin-left: 8px;
					}

					a {
						display: grid;
						grid-template-columns: 1fr;
						gap: 20px;
						font: normal normal normal 16px/24px var(--primary-font-family);

						&.sub-cta {
							font-weight: 600;
							font-size: 15px;
							line-height: 18px;
						}

						&.secondary {
							font-weight: 400;
							font-size: 14px;
							line-height: 18px;
						}

						&:hover {
							text-decoration: underline;
							/* color: var(--cobalt); */
						}
					}

					h5 {
						cursor: pointer;

						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
}

.bounce-enter-active {
	animation: bounce-in 0.5s;
}

.bounce-leave-active {
	animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
	0% {
		transform: translateY(0px);
		opacity: 0;
	}
	50% {
		transform: translateY(30px);
		opacity: 1;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.bounce-reverse-enter-active {
	animation: bounce-in-rev 0.5s;
}

.bounce-reverse-leave-active {
	animation: bounce-in-rev 0.5s reverse;
}

@keyframes bounce-in-rev {
	0% {
		transform: translateY(0px);
		opacity: 0;
	}
	50% {
		transform: translateY(-10px);
		opacity: 1;
	}
	100% {
		transform: translateY(0px);
		opacity: 1;
	}
}

.fade-enter-active {
	animation: fade-in 0.5s;
}

.fade-leave-active {
	animation: fade-in 0.5s reverse;
}

@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.slide-fade-enter-active {
	transition: all 0.25s ease;
	transition-delay: 0.25s;
}
.slide-fade-leave-active {
	pointer-events: none;
	transition: all 0.25s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateY(20px);
	opacity: 0;
}
</style>
